export const PROCESSING_OPTIONS = [
    "Provision of existing data (including sharing)",
    "Provision of existing biosamples",
    "Data hosting",
    "Data analysis",
    "Data compute services",
    "Data curation",
    "(Re-) Pseudonymisation",
    "Generation of data (including sharing of these data where applicable)",
    "Generation of biosamples (including transfer where applicable)",
    "Secondary sharing within consortium as part of the processing / project", // 9 processing10
    "Secondary sharing with external parties as part of the processing / project",
    "Other"
];


